/*  Create common function for callGA4 events */
function callGA4CustomEvent(event, item) {
  
  // Create the base event object
  let eventData = {};

  // Add item data to the event object if item is provided
  // if (item) {
  //   eventData = {
  //     ...item,
  //   };
  // }
  var gtagInterval = setInterval(function () {
  
  if( typeof(gtag) != "undefined"  ){
      clearInterval(gtagInterval);
      console.log("eventName", event);
    
      // Push the event object to dataLayer
      gtag('event', event, eventData );
  }
}, 50);

  

}
/* common function end */


window.onload = function () {
  /* WhatsApp GA4 Event Logic - Start */
  var whatsAppClickInterval = setInterval(function () {
  
    var whatsAppBtnLength = document.getElementsByClassName("whatsapp-icon");

    if (whatsAppBtnLength.length > 0) {
      clearInterval(whatsAppClickInterval);
      whatsAppBtnLength[0].addEventListener("click", function () {
        callGA4CustomEvent("whatsapp_clicks");
      });
    }
  }, 50);
  /* WhatsApp GA4 Event Logic - End */

  /* ===============================================*/

  /* Phone Number GA4 Event Logic - Start */

  var phoneNumberElements = document.querySelectorAll("a[href^='tel:']");
  
  var phoneNumberLength = phoneNumberElements.length;
  
  for (var i = 0; i < phoneNumberLength; ++i) {
    phoneNumberElements[i].addEventListener("click", function () {
      callGA4CustomEvent("phone_number_clicks");
    });
  }

  /* Phone Number GA4 Event Logic - End */

  /* ===============================================*/

  /* Facebook GA4 Event Logic - Start */

  const facebookBtn = document.querySelector(`[title="Facebook"]`);

  facebookBtn.addEventListener("click", function () {
    callGA4CustomEvent("clicks_to_facebook");
  });

  /* Facebook GA4 Event Logic - End */

  /* ===============================================*/

  /* Instagram GA4 Event Logic - Start */

  const InstagramBtn = document.querySelector(`[title="Instagram"]`);

  InstagramBtn.addEventListener("click", function () {
    callGA4CustomEvent("clicks_to_instagram");
  });

  /* Instagram GA4 Event Logic - End */

  /* ===============================================*/

  /* X GA4 Event Logic - Start */

  const XBtn = document.querySelector(`[title="X"]`);

  XBtn.addEventListener("click", function () {
    callGA4CustomEvent("clicks_to_x");
  });

  /* X GA4 Event Logic - End */

  /* ===============================================*/

  /* Linkedin GA4 Event Logic - Start */

  const LinkedinBtn = document.querySelector(`[title="LinkedIn"]`);

  LinkedinBtn.addEventListener("click", function () {
    callGA4CustomEvent("clicks_to_linkedin");
  });

  /* Linkedin GA4 Event Logic - End */

  /* ===============================================*/

  /* Youtube GA4 Event Logic - Start */

  const YoutubeBtn = document.querySelector(`[title="YouTube"]`);

  YoutubeBtn.addEventListener("click", function () {
    callGA4CustomEvent("clicks_to_youtube");
  });

  /* Youtube GA4 Event Logic - End */

  /* ===============================================*/

  const homePage = document.getElementsByClassName("template-index");
  const collectionPage = document.getElementsByClassName("template-collection");
  const searchPage = document.getElementsByClassName("template-search");
  const PDPPage = document.getElementsByClassName("template-product");

  if ( homePage.length > 0 || collectionPage.length > 0 || searchPage.length > 0 || PDPPage.length > 0 ) {
   
    /* Wishlist GA4 Event Logic - Start */

    /* Wishlist-Collection-Page GA4 Event Logic - Start */

    setTimeout(function () {
      var CollectionWishlistClickInterval = setInterval(function () {
        var CollectionWishlistBtnLength = document.querySelectorAll(
          ".wishlist-hero-custom-button button"
        );
        console.log("CollectionWishlistBtnLength", CollectionWishlistBtnLength);

        if (CollectionWishlistBtnLength.length > 0) {
          clearInterval(CollectionWishlistClickInterval);

          CollectionWishlistBtnLength.forEach(function (button) {
            button.addEventListener("click", function () {
              // console.log(this.closest('.productitem__image-container').querySelector(".productitem--image-link").href);
              if (this.getAttribute("aria-label") == "Add to wishlist") {
                let productHandle = this.closest(
                  ".productitem__image-container"
                ).querySelector(".productitem--image-link").href;
                productHandle = productHandle.split("/");
                productHandle = productHandle[productHandle.length - 1];
               productHandle = productHandle.split("?");

                console.log("productHandle", productHandle[0]);

                fetch("/products/" + productHandle[0] + ".js")
                  .then((res) => res.json())
                  .then((res) => {
                    let item = {
                      item_id: res.id,
                      item_name: res.title,
                      item_brand: res.vendor,
                      item_category: res.type,
                      price: res.price,
                      quantity: 1,
                      index: 1,
                    };
                    callGA4CustomEvent("adds_to_wishlist", item);
                  });
              }
            });
          });
        }
      }, 200);
    }, 1000);

    /* Wishlist-Collection-Page GA4 Event Logic - End */

    /* Wishlist-PDP-Page GA4 Event Logic - Start */

    if( PDPPage.length > 0 ) {
        var PDPWishlistClickInterval = setInterval(function () {
        var PDPWishlistBtnLength = document.querySelectorAll(
          ".wishlisthero-product-page-button-container button"
        );
  
        if (PDPWishlistBtnLength.length > 0) {
          clearInterval(PDPWishlistClickInterval);
  
          PDPWishlistBtnLength.forEach(function (button) {
            button.addEventListener("click", function () {
              if (this.getAttribute("aria-label") == "Add to wishlist") {
                let currentProductHandle = window.location.href;
                currentProductHandle = currentProductHandle.split("/");
                currentProductHandle =
                  currentProductHandle[currentProductHandle.length - 1];
                 currentProductHandle = currentProductHandle.split("?");
  
  
                fetch("/products/" + currentProductHandle[0] + ".js")
                  .then((res) => res.json())
                  .then((res) => {
                    let item = {
                      item_id: res.id,
                      item_name: res.title,
                      item_brand: res.vendor,
                      item_category: res.type,
                      price: res.price,
                      quantity: 1,
                      index: 1,
                    };
                    callGA4CustomEvent("adds_to_wishlist", item);
                  });
              }
            });
          });
        }
      }, 50);
    }
    /* Wishlist-PDP-Page GA4 Event Logic - End */

    /* Wishlist GA4 Event Logic - End */
  }
};